import { IllegalArgumentError } from 'faro-common-model';
import { z } from 'zod';
import { uuidish } from '../../utils/uuidish.js';
export const assignAmConfigTypeSchema = z.enum([
    'StudyAssessmentMeasurement',
    'BiomedicalAssessmentMeasurement',
    'AssessmentMeasurementConfiguration',
]);
export const assignAmConfigPayloadSchema = z.object({
    type: assignAmConfigTypeSchema,
    id: uuidish,
    sequenceNumber: z.number().optional(),
});
/**
 * Converts a JSON object to an AssignAmConfigPayload.
 */
export function toAssignAmConfigPayload(payload) {
    const result = assignAmConfigPayloadSchema.safeParse(payload);
    if (!result.success) {
        throw new IllegalArgumentError(`Invalid AssignAmConfigPayload object. ${result.error.message}`);
    }
    return result.data;
}
//# sourceMappingURL=assign-am-config-payload.js.map